import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../utils/firebase.js';
import { Suspense, useState, useEffect } from 'react';
import '../App.css';
import SiteNav from '../components/SiteNav.js';
import { useLoaderData } from "react-router-dom";
import { getNewGameComponent, getOngoingGameComponent } from '../utils/gameComponents.js';
import { _getGame, _saveUserGameTracker, _getGameRef } from '../data/gameTrackers.js';
import { _getSharedGame, _saveSharedUserGameTracker, _getSharedGameRef } from '../data/sharedGameTrackers.js';
import Loading from '../components/Loading.js';

export async function loader({ params }) {
    return { gameId: params.gameId, campaignId: params.id };
}

export const NewCampaign = () => {
    const gameId = useLoaderData().gameId;
    const GameComponent = getNewGameComponent(gameId);
    const [user, setUser] = useState(auth.currentUser);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setUser(user);
        });

        return () => unsubscribe();
    }, []);


    return (
        <div>
            <SiteNav />
            {!user ?
                <div className="container pl-2 pr-2 mt-3 indent-from-top">
                    Looks like you're not logged in. <a href="/" className="is-link is-underlined">Click here</a> to back to the home page and log in, then try again.
                </div>
                : GameComponent ? (
                    <Suspense fallback={<Loading />}>
                        <GameComponent />
                    </Suspense>
                ) : (
                    <div className="container pl-2 pr-2 mt-5 indent-from-top">
                        Game not found. Make sure you are logged in and have the right URL.
                    </div>
                )}
        </div>
    );
}

export const OngoingCampaign = () => {
    const gameId = useLoaderData().gameId;
    const campaignId = useLoaderData().campaignId;
    const GameComponent = getOngoingGameComponent(gameId);
    const [user, setUser] = useState(auth.currentUser);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setUser(user);
        });

        return () => unsubscribe();
    }, []);

    return (
        <div>
            <SiteNav />
            {
                !user ?
                    <div className="container pl-2 pr-2 mt-3 indent-from-top">
                        Looks like you're not logged in. <a href="/" className="is-link is-underlined">Click here</a> to back to the home page and log in, then try again.
                    </div>
                    : GameComponent ? (
                        <Suspense fallback={<Loading />}>
                            <GameComponent gameId={campaignId} _getGame={_getGame} _saveUserGameTracker={_saveUserGameTracker} _getGameRef={_getGameRef} />
                        </Suspense>
                    ) : (
                        <div className="container pl-2 pr-2 mt-3  indent-from-top">
                            Game not found. Make sure you are logged in and have the right URL.
                        </div>
                    )}
        </div>
    );
}

export const SharedCampaign = () => {
    const gameId = useLoaderData().gameId;
    const trackerId = useLoaderData().campaignId;
    const GameComponent = getOngoingGameComponent(gameId);
    const [user, setUser] = useState(auth.currentUser);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setUser(user);
        });

        return () => unsubscribe();
    }, []);

    return (
        <div>
            <SiteNav />
            {!user ?
                <div className="container pl-2 pr-2 mt-3">
                    Looks like you're not logged in. <a href="/" className="is-link is-underlined">Click here</a> to back to the home page and log in, then try again.
                </div>
                : GameComponent ? (
                    <Suspense fallback={<Loading />}>
                        <GameComponent gameId={trackerId} _getGame={_getSharedGame} _saveUserGameTracker={_saveSharedUserGameTracker} _getGameRef={_getSharedGameRef} />
                    </Suspense>
                ) : (
                    <div className="container pl-2 pr-2 mt-3">
                        Game not found. Make sure you are logged in and have the right URL.
                    </div>
                )}
        </div>
    );
}
